export enum SOCKET_TICKET_ENTRY {
  send = 'send:ticket',
  sendTicketSerie = 'send:ticket-serie',
}
